import {TitleSummaryTemplate} from '../../entity/model/title-summary-template';
import {TitleSummaryTemplateDto} from '../../entity/dto/title-summary-template-dto';
import TitleSummaryTemplateStore from '../store/title-summary-template-store';
import {toast} from 'react-toastify';

export default class TitleSummaryTemplateService {
  constructor(private titleSummaryTemplateStore: TitleSummaryTemplateStore) {}

  getTitleSummaryTemplates = async (organizationId: string, reload: boolean): Promise<TitleSummaryTemplate[]> => {
    return this.titleSummaryTemplateStore.cache && !reload
      ? this.titleSummaryTemplateStore.titleSummaryTemplates
      : this.titleSummaryTemplateStore.getTitleSummaryTemplates(organizationId);
  }

  filterTemplates = (input: string): TitleSummaryTemplate[] => {
    return this.titleSummaryTemplateStore.titleSummaryTemplates.filter((template: TitleSummaryTemplate) => {
      return template.templateName.trim().toLowerCase().includes(input.toLowerCase());
    });
  }

  getTitleSummaryTemplateDto = (): TitleSummaryTemplateDto => {
    return {
      templateName: '',
      includeOrderInfo: true,
      includePropertyInfo: true,
      includeOwnerInfo: true,
      includeVestingDeed: true,
      includeTaxes: true,
      includeMortgages: true,
      includeEstates: true,
      includeJudgments: true,
      includeLiens: true,
      includeUCCs: true,
      includeRestrictions: true,
      includeEasements: true,
      includeGeneralComments: true,
      includeMobileHome: true
    };
  }

  createTitleSummaryTemplate = async (organizationId: string, titleSummaryTemplate: TitleSummaryTemplate): Promise<void> => {
    const result = await this.titleSummaryTemplateStore.createTitleSummaryTemplate(organizationId, { body: titleSummaryTemplate });
    if (typeof result === 'string')
      toast.error(result);
    else
      toast.success('Title summary template created successfully!');
  }
}
